var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { makeStyles } from "@material-ui/core";
import { FTLTypography } from "../FTLTypography";
import { colors } from "../../shared/colors";
export const FTLBadge = (_a) => {
    var { backgroundColor, textColor = "onColor", children, className = "" } = _a, otherProps = __rest(_a, ["backgroundColor", "textColor", "children", "className"]);
    const classes = useStyles({ backgroundColor });
    return (React.createElement(FTLTypography, Object.assign({ variant: "tooltip", color: textColor, className: classes.root + " " + className }, otherProps), children));
};
const useStyles = makeStyles({
    root: ({ backgroundColor = "textTertiary", }) => ({
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        minWidth: 20,
        height: 20,
        padding: "2px 6px",
        boxSizing: "border-box",
        backgroundColor: colors[backgroundColor],
        borderRadius: 10,
    }),
});
//# sourceMappingURL=index.js.map